module.exports = __webpack_public_path__ + "img/RedMercedesAmg.49ae8c01.jpg";